export const customRequire = (componentName) => {
  return require(`./${componentName}.svelte`)
}
